import script from "./SidebarPathITem.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarPathITem.vue?vue&type=script&lang=ts&setup=true"

import "./SidebarPathITem.vue?vue&type=style&index=0&id=0bd42a95&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bd42a95"]])

export default __exports__